@if (!isMobile) {
    <app-scroll-wrapper [classes]="['banner-container', 'whats-banner']" [enableScrollListener]="true">
        <ng-container [ngTemplateOutlet]="renderBanners" [ngTemplateOutletContext]="{ banners: firstRowBanners }"></ng-container>
    </app-scroll-wrapper>
} @else {
    <div class="mobile-wrapper">
        <div class="whats-banner">
            <ng-container
                [ngTemplateOutlet]="renderBanners"
                [ngTemplateOutletContext]="{ banners: firstRowBanners }"></ng-container>
        </div>
        <div class="whats-banner">
            <ng-container
                [ngTemplateOutlet]="renderBanners"
                [ngTemplateOutletContext]="{ banners: secondRowBanners }"></ng-container>
        </div>
    </div>
}

<ng-template #renderBanners let-banners="banners">
    @for (banner of banners; let i = $index; track banner) {
        <div>
            <img
                scroll-item
                role="button"
                tabindex="0"
                alt="offer-banner"
                [imageSrc]="banner.image"
                appDeferImageLoad
                (click)="handleClick(banner, i)" />
            <span class="label">{{ banner.name }}</span>
        </div>
    }
</ng-template>
